<template>
  <div class="camping-about" v-if="campingDetail && campingDetail.acf">
    <div class="conter-inner">
      <div class="row">
        <div class="col-sm-7 camping-aleft">
          <h2 class="relative-section section-title font-balo font-bold">
            <span>{{ campingDetail.acf.camse_subtitle }}</span>
            <b>{{ campingDetail.acf.camse_title }}</b>
          </h2>
          <div class="des font-bai" v-html="campingDetail.acf.camse_des"></div>
        </div>
        <div class="col-sm-5">
          <div class="image-fit">
            <img v-if="campingDetail.acf.camse_image" :src="campingDetail.acf.camse_image" alt />

            <img v-if="!campingDetail.acf.camse_image" src="../assets/images/canping-about.jpg" alt />
          </div>
        </div>
      </div>
      <div class="camping-services" v-if="campingDetail.acf.camse_service_list.length > 0">
        <h2 class="font-bai font-bold" v-html="campingDetail.acf.camse_service_title"></h2>
        <ul class="list-inline camping-svlist">
          <li
            class="item-inline"
            v-for="(item, index) in campingDetail.acf
                            .camse_service_list"
            :key="index"
          >
            <a href @click.prevent class="text-center svitem font-bai">
              <div class="image" v-if="item.icon">
                <img :src="item.icon" :alt="item.name" />
              </div>
              <b>{{ item.name }}</b>
            </a>
          </li>
        </ul>
        <div class="text-center">
          <a @click.prevent="onGotoSearchPage()" class="btn font-balo font-bold">
            {{
            campingDetail.acf.camse_button_text
            ? campingDetail.acf.camse_button_text
            : $t("app.réserver dans ce parc 1")
            }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import moment from "moment";
import { ADULT_COUNT_DEFAULT } from "@/api/config";
import { formatBookDate } from "@/helper/calculateDays";
import { get } from "lodash";
export default {
  name: "CampingAbout",
  computed: {
    ...mapState({
      campingDetail: state => get(state, "campingClubs.detail", null)
    })
  },
  methods: {
    ...mapMutations("hotels", ["setFilter"]),
    onGotoSearchPage() {
      let dataReferences = {
        camping: this.campingDetail.id,
        dateFrom: formatBookDate(moment()),
        dateTo: formatBookDate(moment().add(1, "day")),
        adult: ADULT_COUNT_DEFAULT,
        child: 0,
        child1: 0
      };
      this.setFilter(dataReferences);
      this.$router.push("/result");
    }
  }
};
</script>
